import { IConfig } from './IConfig'

export const configDevelopment: IConfig = {
  api: {
    url: 'https://fb-ig-booking-app.dev.blvd.co'
  }
}
